import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.min.css'

// 设置Vue全局配置
console.log('配置Vue应用...');

// 创建Vue应用实例
const app = createApp(App);

// 添加全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue全局错误:', err);
  console.error('错误信息:', info);
};

// 启用性能跟踪 (仅在开发模式)
if (process.env.NODE_ENV === 'development') {
  app.config.performance = true;
}

// 使用路由
console.log('注册路由插件...');
app.use(router);
console.log('路由配置完成');

// 提供路由实例给所有组件
app.provide('router', router);

// 全局钩子，用于调试
app.mixin({
  created() {
    if (this.$options.name) {
      console.log(`组件创建: ${this.$options.name}`);
    }
  },
  mounted() {
    if (this.$options.name) {
      console.log(`组件挂载: ${this.$options.name}`);
    }
  }
});

// 挂载应用
console.log('挂载应用到 #app');
app.mount('#app');

// 添加日志记录
console.log('应用已启动，路由已激活');

// 为调试添加全局路由对象
window.vueRouter = router;

/**
 * 项目静态资源目录说明：
 * 图片文件夹结构：
 * - src/assets/images/         - 所有图片资源的主目录
 *   - products/                - 产品相关图片
 *   - backgrounds/             - 背景图片
 *   - logos/                   - Logo和图标
 * 
 * 在组件中引用图片示例：
 * 1. <img src="@/assets/images/logos/logo.png"> - 使用相对路径
 * 2. import logo from '@/assets/images/logos/logo.png' - JS中导入
 */